import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { TabbedView, TabDefinition } from '@gik/ui';

import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import UpcomingClaimsList from './UpcomingClaimsList';
import HistoryClaimsList from './HistoryClaimsList';

const blockName = 'claimed-items';

export interface IClaimedItemsProps {}

export default function ClaimedItems() {
  const { t } = useTranslation();

  const bem = bemBlock(blockName);

  const tabs: TabDefinition[] = [
    {
      title: t(translationKeys.claimed),
      content: <UpcomingClaimsList />,
    },
    {
      title: t(translationKeys.history),
      content: <HistoryClaimsList />,
    },
  ];

  return <TabbedView className={bem()} tabs={tabs} />;
}
